import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter} from "@angular/core";
import {interval} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';


declare var $:any;
declare var swal:any;
declare var tagsinput:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-sharing',
    templateUrl: 'sharing.component.html',
    styleUrls: ['sharing.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.SubscriptionService,],
    standalone: false
})
export class SharingComponent implements OnInit, OnDestroy {

  @Input() document:any = {}; // data coming from details or jobs component
  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];
  emailItems:string[] = [];
  theJob:Communication.Job;
  message:string;

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private usersApi:Communication.UsersService,
              private subscriptionsApi:Communication.SubscriptionService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              private notificationService: NotificationService,
              private translate: TranslateService
  )
  {




  }


  ngOnInit() {

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {

      console.log("document: " + this.document.id +" - "+ this.document.name);
      this.initInputTagsScript();
    }
  }


  initInputTagsScript(){
    let _thisInput = this;

    $('input[type=text].tags-input').val('');

    // Basic initialization
    $('.tags-input').tagsinput();

    //https://bootstrap-tagsinput.github.io/bootstrap-tagsinput/examples/
    $('.tags-input').on('beforeItemAdd', function(event:any) {
      let email = event.item;
      if(!_thisInput.validateEmail(email)) {
        console.log(email + " : not match email criteria!");
        event.cancel = true; // don't add
      }
    });

   /* $(".tags-input").on('focusout', function(event:any) {
      let code = event.keyCode || event.which;
      console.log("clicked code: " + code);

      //if(code == 13 || code == 9) { //Enter keycode or tab keycode
        let email = event.item;

        if(email) {
          $('.tags-input').tagsinput('add', email);

          let $element = $(event.target);
          _thisInput.emailItems = $element.tagsinput('items');
        }
     //}

      console.log("on focusout, size: " + _thisInput.emailItems.length + " - "+ JSON.stringify(_thisInput.emailItems))
    });*/

    $('.tags-input').on('change', function(event:any) {

      let $element = $(event.target);
      if (!$element.data('tagsinput')) return;

      let beforeChange = _thisInput.emailItems;
      _thisInput.emailItems = $element.tagsinput('items');
      console.log("on change, size: " + _thisInput.emailItems.length + " - "+ JSON.stringify(_thisInput.emailItems))
      //console.log("on change " + JSON.stringify($element.tagsinput('items')))

      //stop timer when initialize
      this.timerSubscription = interval(100).subscribe(x => {
        if(beforeChange == _thisInput.emailItems) {}
        else{
          if (_thisInput.timerSubscription != null)
            _thisInput.timerSubscription.unsubscribe();
        }
      });

    }).trigger('change');

  }

  validateEmail(email:string):boolean {
    //let pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;  //only mail adress
    let pattern = /^(?:"?([^"]*)"?\s)?(?:<?([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}[^>]+)>?)$/;  // name and mail address
    return pattern.test(email);
}

  share(){
    console.log("data: " + this.message + ' - ' + this.emailItems + " - " + this.document.id.toString())

    this.subscriptions.push(this.jobsApi.jobsIdActionsShareattachmentPost(this.authorization.getAccessToken(), this.document.id.toString(), this.emailItems.toString(), this.message).subscribe(
      (response) => {
        console.log("Document shared...");
        this.notificationService.documentShared();
        $(".tags-input").tagsinput('removeAll'); // remove list
        this.message = "";
        this.emailItems = [];
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
        $(".tags-input").tagsinput('removeAll'); // remove list
        this.message = "";
        this.emailItems = [];
      }
    ));

  }


  ngOnDestroy() {
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }
}
